import {withStyles} from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

const StyledTableCell = withStyles((theme) => ({
  head: (props) => ({
    backgroundColor: props.disableBackground
      ? theme.palette.common.white
      : theme.palette.primary.main,
    color: props.disableBackground
      ? theme.palette.text.primary
      : theme.palette.common.white,
    border: props.disableHeadBorders
      ? 'none'
      : `1px solid ${
          props.secondaryBorders ? 'rgba(122,122,122, 0.2)' : '#ADDFFE'
        }`,
    fontWeight: 700,
    padding: props.compact ? 0 : 11,
  }),
  body: (props) => ({
    '&:not(.cms)': {
      fontSize: 14,
      color: theme.palette.primary.main,
      fontWeight: 300,
      border: props.secondaryBorders
        ? '0.5px solid rgba(122,122,122, 0.2)'
        : '1px solid #ADDFFE',
      padding: props.compact ? 0 : 11,
    },
  }),
}))(TableCell);

export default StyledTableCell;
